import { render, staticRenderFns } from "./OnLineIndex.vue?vue&type=template&id=4145fad0&scoped=true"
import script from "./OnLineIndex.vue?vue&type=script&lang=js"
export * from "./OnLineIndex.vue?vue&type=script&lang=js"
import style0 from "./OnLineIndex.vue?vue&type=style&index=0&id=4145fad0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145fad0",
  null
  
)

export default component.exports